<template>
  <v-dialog
    v-if="leadId > 0"
    :model-value="true"
    max-width="1200"
    scrollable
    @update:model-value="$emit('update:leadId', null)"
  >
    <v-card max-height="85vh">
      <v-toolbar
        flat
        color="primary"
        dark
      >
        <v-toolbar-title>Details for lead: {{ leadId }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          dark
          @click="$emit('update:leadId', null)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text v-if="isLoading">
        <div class="text-center ma-15">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          />
        </div>
      </v-card-text>

      <v-tabs
        v-if="!isLoading"
        v-model="tabs"
        color="primary"
        background-color="white"
      >
        <v-tab value="0">
          Submitted Lead
        </v-tab>
        <v-tab value="1">
          Waterfall Results
        </v-tab>
        <v-tab value="2">
          FullStory sessions
        </v-tab>
        <v-tab value="3">
          Loanpro Tracking
        </v-tab>
      </v-tabs>

      <v-divider v-if="!isLoading" />

      <v-card-text v-if="!isLoading">
        <v-window v-model="tabs">
          <v-window-item value="0" eager>
            <v-card
              flat
              class="pa-5"
            >
              <JsonFormatterWrapper :data="leadDetails.submittedLead" />
              <LeadConfirmDecryptButtons
                v-if="hasPermission('view pii')"
                :form-processing="isLoading"
                @decrypt="loadDecrypted($event)"
              />
            </v-card>
          </v-window-item>
          <!-- ./ Submitted Lead -->

          <v-window-item value="1" eager>
            <WaterfallResults :data="waterfallLog" />
          </v-window-item>
          <!-- ./ Waterfall Results -->

          <v-window-item value="2" eager>
            <FullStorySessions :sessions="leadDetails.fullStorySessions" />
          </v-window-item>
          <!-- ./ FullStory sessions -->

          <v-window-item value="3" eager>
            <v-card flat>
              <v-card-title> Loanpro Tracking </v-card-title>
              <JsonFormatterWrapper
                :data="leadDetails.loanproTracking"
                class="pa-5 pt-0"
              />
            </v-card>
          </v-window-item>
        </v-window>
      </v-card-text>

      <v-divider v-if="!isLoading" />

      <v-card-actions v-if="!isLoading">
        <v-card-text class="pl-5 pb-0">
          <h2 class="pb-4">
            Client Response
          </h2>
          <JsonFormatterWrapper :data="clientResponse" />
        </v-card-text>
      </v-card-actions>

      <v-card-actions />
    </v-card>
  </v-dialog>
</template>

<script>

import JsonFormatterWrapper from '../JsonFormatterWrapper.vue';
import FullStorySessions from './FullStorySessions.vue';
import WaterfallResults from './WaterfallResults.vue';
import LeadConfirmDecryptButtons from './LeadConfirmDecryptButtons.vue';

export default {
  name: 'LeadDetails',

  components: {
    FullStorySessions,
    WaterfallResults,
    JsonFormatterWrapper,
    LeadConfirmDecryptButtons,
  },

  props: {
    leadId: {
      type: Number,
    },
  },

  data() {
    return {
      tabs: '0',
      show: true,
      leadDetails: {
        submittedLead: {},
        waterfallResults: {},
        fullStorySessions: [],
        loanproTracking: {},
      },
      isLoading: true,
    };
  },

  computed: {
    waterfallLog() {
      return JSON.parse(this.leadDetails.waterfallResults?.log_data ?? '{}');
    },

    clientResponse() {
      return JSON.parse(this.waterfallLog?.client_raw_response ?? '{}');
    },
  },

  async created() {
    const { status, data } = await this.$axios.get(
      `api/v1/lead/${this.leadId}/details`,
    );

    if (status === 200) {
      this.leadDetails = Object.assign(this.leadDetails, data);
    }

    this.isLoading = false;
  },

  methods: {
    loadDecrypted(reason) {
      this.isLoading = true;

      return this.$axios
        .post(`api/v1/lead/${this.leadId}/decrypt-details`, { reason })
        .then((res) => {
          if (res.status === 200) {
            this.leadDetails = Object.assign(this.leadDetails, res.data);
          }

          this.isLoading = false;
        });
    },
  },

};
</script>

<style scoped>
.v-dialog__content {
  align-items: start;
  margin-top: 15px;
}

/* Force v-tabs visibility */
.v-tabs {
  background-color: transparent !important;
  min-height: 48px !important;
}

.v-tab {
  opacity: 1 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.0892857143em !important;
}
</style>
